// -----------------------------------------------------------
// FloraIQ - PointCloudOverview — Aba Visão Geral
// -----------------------------------------------------------

import { ladmIntegrationCards } from "@/mocks/pointcloud";
import { useState } from "react";

const overviewChartData = [
  { label: "Drone LiDAR", valor: 6, cor: "#0052CC" },
  { label: "Drone RGB", valor: 4, cor: "#64B5F6" },
  { label: "Laser Scanner", valor: 3, cor: "#1B6E4F" },
  { label: "LiDAR Aéreo", valor: 2, cor: "#CAF0D3" },
  { label: "GNSS/GPS", valor: 2, cor: "#F57C00" },
  { label: "Fotogramétrico", valor: 2, cor: "#FBC02D" },
  { label: "Modelo 3D", valor: 1, cor: "#795548" },
  { label: "Misto", valor: 1, cor: "#607D8B" },
];

const alertCards = [
  { title: "Nuvens sem classificação concluída", value: 7, icon: "ri-stack-line", color: "warning" },
  { title: "Levantamentos aguardando processamento", value: 4, icon: "ri-time-line", color: "warning" },
  { title: "Divergências campo x 3D pendentes", value: 14, icon: "ri-contrast-2-line", color: "danger" },
  { title: "Metadados incompletos", value: 4, icon: "ri-file-info-line", color: "danger" },
];

export default function PointCloudOverview() {
  const [expandedCard, setExpandedCard] = useState<string | null>(null);
  const maxBarVal = Math.max(...overviewChartData.map((d) => d.valor));

  return (
    <div className="space-y-5">
      {/* Gráficos Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* Levantamentos por tipo */}
        <div className="bg-white rounded-card border border-background-200/70 p-4">
          <h4 className="text-sm font-bold text-foreground-900 font-heading mb-4">Levantamentos por Tipo</h4>
          <div className="space-y-2.5">
            {overviewChartData.map((d) => (
              <div key={d.label} className="flex items-center gap-3">
                <span className="text-xs text-foreground-600 w-28 whitespace-nowrap truncate">{d.label}</span>
                <div className="flex-1 h-5 bg-background-100 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-700"
                    style={{ width: `${(d.valor / maxBarVal) * 100}%`, backgroundColor: d.cor }}
                  ></div>
                </div>
                <span className="text-xs font-bold text-foreground-700 w-6 text-right">{d.valor}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Alertas + Integração */}
        <div className="space-y-4">
          {/* Alertas */}
          <div className="bg-white rounded-card border border-background-200/70 p-4">
            <h4 className="text-sm font-bold text-foreground-900 font-heading mb-3">Alertas</h4>
            <div className="grid grid-cols-2 gap-2">
              {alertCards.map((a) => (
                <div key={a.title} className="flex items-center gap-2.5 p-2.5 rounded-lg bg-background-50/50 border border-background-200/50">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${a.color === "warning" ? "bg-amber-100 text-amber-600" : "bg-red-100 text-red-600"}`}>
                    <i className={`${a.icon} text-sm`}></i>
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-foreground-500 truncate">{a.title}</p>
                    <p className="text-sm font-bold text-foreground-900 font-heading">{a.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Integração LADM */}
      <div>
        <h4 className="text-sm font-bold text-foreground-900 font-heading mb-3">Integração com Metodologia FloraIQ-LADM</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {ladmIntegrationCards.map((card) => (
            <div
              key={card.title}
              className="bg-white rounded-card border border-background-200/70 p-4 hover:shadow-sm transition-shadow cursor-pointer"
              onClick={() => setExpandedCard(expandedCard === card.title ? null : card.title)}
            >
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${card.color === "info" ? "bg-blue-100 text-blue-600" : "bg-green-100 text-green-600"}`}>
                  <i className={`${card.icon} text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h5 className="text-xs font-bold text-foreground-900 font-heading">{card.title}</h5>
                  <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{card.description}</p>
                  {expandedCard === card.title && (
                    <div className="mt-2 pt-2 border-t border-background-200/50">
                      <span className="text-xs text-primary-500 font-medium cursor-pointer hover:underline">Ver detalhes na metodologia LADM</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}